import { useFeatureValue } from '@shared/core/featureFlags';
import { useIsMobileOrTablet } from '@shared/utils/media/useMediaScreens';

export const useRegistryCatalogFiltersOpenDefaultEnabled = (options?: { skipIf?: boolean }) => {
  const isMobileOrTablet = useIsMobileOrTablet();
  const flagValue = useFeatureValue('registryCatalogFiltersOpenDefaultEnabled', { skip: isMobileOrTablet || options?.skipIf }).value === 'treatment';
  return { registryCatalogFiltersOpenDefaultEnabled: flagValue };
};
